(function () {
    angular.module('tradersyard').controller('group-create-ctrl', GroupCreateCtrl);

    GroupCreateCtrl.$inject = ['$scope', '$window', 'graph-group-factory', '$flex', 'InvitationService'];

    /**
     * Handles creation of Groups and sub-Groups, as well as Exhibition Booths (which are also Groups).
     *
     * @param {angular.IScope} $scope
     * @param {angular.IWindowService} $window
     * @param groupFactory
     * @param $flex
     * @param InvitationService
     * @constructor
     */
    function GroupCreateCtrl($scope, $window, groupFactory, $flex, InvitationService) {
        // region: props

        $scope.$error = {};
        $scope.errors = {};
        $scope.buffer = {};
        $scope.duration = 0;
        $scope.queue = 0;
        $scope.queueConfirm = 0;
        $scope.order_info = undefined;
        $scope.exhibition = undefined;

        // Group data
        $scope.node = {
            title: '',
            description: '',
            privacy: 'public',
            category: 0,
            order_number: '',
        };

        $scope.parent = {};

        // endregion

        // region: init

        if ($flex.data.node) {
            angular.extend($scope.node, $flex.data.node);
        }

        if ($flex.data.exhibition) {
            $scope.exhibition = $flex.data.exhibition;
        }

        if ($flex.data.parent) {
            angular.extend($scope.parent, $flex.data.parent);
            $scope.node.privacy = $scope.parent.privacy;
        }

        _loadCategories();

        // endregion: init

        // region: methods

        $scope.load = {
            categories: _loadCategories,
        };

        $scope.submit = function () {
            if ($scope.queue === 0) {
                $scope.queue = 1;
                $scope.create($scope.node);
            }
        };

        $scope.create = createGroup;

        $scope.confirmOrder = function () {
            if ($scope.queueConfirm === 0 && $scope.node.order_number != '') {
                $scope.queueConfirm = 1;

                $scope.create($scope.node);
            }
        };

        $scope.scheduledHandlingNewOrder = undefined;

        $scope.handleNewOrder = function (booth) {
            $scope.scheduledHandlingNewOrder = setInterval(function () {
                groupFactory
                    .handleOrder(booth.id)
                    .then(function (response) {
                        if (response.data.state == 0) {
                            $scope.node.order_number = response.data.data.id || '';
                            $scope.order_info = response.data.data;

                            clearInterval($scope.scheduledHandlingNewOrder);
                            $scope.scheduledHandlingNewOrder = undefined;
                        }
                    })
                    .catch(function (response) {
                        $scope.errors = response.data.data;
                    });
            }, 3000);

            window.open(booth.url, '_blank');
        };

        $scope.onSubscriptionPlanChanges = function onSubscriptionPlanChanges(subscription) {
            $scope.node.subscription = {
                plan_type: subscription.plan,
                product_id: subscription.product?.productId,
            };
        };

        // endregion

        function _loadCategories() {
            groupFactory.categories().then(function (response) {
                if (response.data.state === 0) {
                    $scope.categories = response.data.data;
                }
            });
        }

        async function createGroup(data) {
            $scope.errors = {};

            const newGroupData = {
                ...data,
                parent_id: $scope.parent.id,
                category_id: data.category.id,
            };

            // Append Exhibition related data if we are creation an Exhibition Booth
            if ($scope.exhibition) {
                newGroupData.exhibition_id = $scope.exhibition.id;
                newGroupData.class_id = $scope.exhibition.class_id;
            }

            try {
                // create group and then...
                const groupData = await groupFactory.createGroup(newGroupData);

                // Sub-groups should show an invitation modal right away.
                if (groupData.parent_id) {
                    // ...show an invitation popup, so we can immediately invite some people...
                    await InvitationService.openInviteModalForSubGroup(groupData.id, groupData.parent_id);
                }

                // ...when invite modal is closed, redirect to the created group.
                $window.location.replace('/group/' + groupData.id);
            } catch (errors) {
                $scope.errors = errors;
                // only clear the loading status on errors.
                // on success we wait for redirect to happen anyway.
                $scope.queue = 0;
                $scope.queueConfirm = 0;
            } finally {
                // we need to run $digest in async/await
                $scope.$digest();
            }
        }
    }
})();
